<template>
  <v-container class="max-width-1200">

    <v-row class="text-justify justify-center">
      <v-col>

        <v-row class="justify-center">
          <v-col class="align-center d-flex">
            <v-img
              src="@/assets/em/rubicon_mockup_01.png"
              max-width="350"
              contain
              class="ml-12 mx-auto">
            </v-img>
          </v-col>
          <v-col>
            <v-row>
              <v-col class="pb-0 headline text-uppercase">
                {{ $t('rubicon.software.title') }}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="display-1">
                {{ $t('rubicon.software.subtitle')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-justify">
                {{ $t('lorem.01')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-justify">
                {{ $t('lorem.01')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-justify">
                {{ $t('lorem.01')}}
              </v-col>
            </v-row>
          </v-col>
        </v-row>

      </v-col>
    </v-row>

    <v-row>
      <v-col>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'RubiconSoftware',
    extends: DataComponentBase,

    data: () => ({

    }),

    methods: {

    },
  }
</script>
